export const FOREIGN_ACCOUNTS = [
  ['foreignAccountEuService', 'EU-Dienstleistung – Reverse Charge'],
  ['foreignAccountEuSupply', 'Innergemeinschaftliche Lieferung'],
  ['foreignAccountExportSupply', 'Ausfuhrlieferung'],
  ['foreignAccountThirdCountryService', 'Dienstleistung im Drittland'],
];

export const emptyForeignAccounts = () => Object.fromEntries(FOREIGN_ACCOUNTS.map(([field]) => [field, '']));
